import React, { useEffect, useState } from 'react';
import { confirmChangeEmail, logout } from '../services/auth.service';
import LoadingSpinner from '../components/LoadingSpinner';
import { Link } from 'react-router-dom';
import { getUrlParams } from '../services/parameter.service';
import { useAuth } from '../contexts/AuthContext';

const ChangeEmailAddressPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [successful, setIsSuccessful] = useState(false);

  const { token, email } = getUrlParams();

  const { userInfo } = useAuth();

  const confirm = async () => {
    const result = await confirmChangeEmail(email, token);
    if (result.success) {
      setIsSuccessful(true);
      await logout();
      window.location.href = `/Account/Login?emailChanged=${encodeURIComponent(email)}`;
    }
    setLoading(false);
  };

  useEffect(() => {
    confirm();
  }, []);

  return (
    <div>
      {loading && <LoadingSpinner />}
      {!loading && successful && (
        <div>
          Email address changed from {userInfo && userInfo.emailAddress} to{' '}
          {email}. Please <Link to="/Account/Login">log in</Link>.
        </div>
      )}
      {!loading && !successful && <div>Invalid link, please try again.</div>}
    </div>
  );
};

export default ChangeEmailAddressPage;
